var faqHeaderLinkClass = ".faqHeaderLinkComponent";
var fancyBoxInnerClass = "#faq-subcategories li";
var faqLinkContainerClass = ".faq-link-container-addon";
var cartPath = "/cart";
var mainFaqURL = "/scontent/faq/";

function show(id) {

    var inputs = document.getElementsByTagName("div");
    if (inputs.length > 0) {
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].id.indexOf("subcategory") == 0)
                inputs[i].style.display = 'none';
        }
    }

    var el = document.getElementById(id);
    el.style.display = 'block';

}

$(document).ready(function () {
    if (cartPath === window.location.pathname) {
        $(faqHeaderLinkClass).on('click', function (event) {
            event.preventDefault();
            ajaxCall(mainFaqURL);
        });
    }
});

function initEvents() {
    $(fancyBoxInnerClass).on('click', function (event) {
        if (!~$(this)[0].getElementsByTagName("a")[0].getAttribute("href").indexOf('#')) {
            event.preventDefault();
            ajaxCall($(this)[0].getElementsByTagName("a")[0].getAttribute("href"));
        }
    });

    $(faqLinkContainerClass).on('click', function (event) {
        event.preventDefault();
        ajaxCall($(this)[0].getElementsByTagName("a")[0].getAttribute("href"));
    });


}

function ajaxCall(url) {
    $.ajax({
        dataType: "html",
        headers: {
            'Fancybox-request': 'true'
        },
        url: url,
        success: function (innerData) {
            $.fancybox({
                width: 980,
                height: 700,
                fitToView: true,
                autoSize: false,
                content: innerData
            });
        }
    }).done(function () {
        initEvents();
    });
}